// Модальное окно для просмотра изображений
(function() {
    'use strict';

    // Создание структуры модального окна
    function createImageModal() {
        // Проверяем, не существует ли уже модальное окно
        if (document.getElementById('imageModal')) {
            return;
        }

        const modal = document.createElement('div');
        modal.id = 'imageModal';
        modal.className = 'image-modal';
        modal.innerHTML = `
            <div class="image-modal__overlay"></div>
            <div class="image-modal__container">
                <button class="image-modal__close" aria-label="Закрыть">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </button>
                <div class="image-modal__content">
                    <div class="image-modal__image-wrapper">
                        <img class="image-modal__image" src="" alt="">
                    </div>
                    <div class="image-modal__caption"></div>
                </div>
                <button class="image-modal__nav image-modal__nav--prev" aria-label="Предыдущее изображение">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
                <button class="image-modal__nav image-modal__nav--next" aria-label="Следующее изображение">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
        `;

        document.body.appendChild(modal);

        // Добавляем стили
        const style = document.createElement('style');
        style.textContent = `
            .image-modal {
                display: none;
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                z-index: 99999;
                animation: fadeIn 0.3s ease;
            }

            .image-modal.active {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .image-modal__overlay {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(0, 0, 0, 0.9);
                cursor: pointer;
            }

            .image-modal__container {
                position: relative;
                width: 100vw;
                height: 100vh;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer; /* Добавляем курсор указатель */
            }

            .image-modal__content {
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: center;
                width: 100%;
                height: 100%;
                justify-content: center;
                cursor: default; /* Сброс курсора для контента */
            }
            
            .image-modal__image-wrapper {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                overflow: hidden;
                cursor: pointer; /* Курсор-указатель на wrapper */
            }
            
            .image-modal__image-wrapper.zoomed {
                overflow: auto;
                cursor: move; /* В режиме зума - курсор перемещения */
            }

            .image-modal__image {
                max-width: 90vw;
                max-height: 90vh;
                width: auto !important; /* Важно для правильного размера */
                height: auto !important; /* Важно для правильного размера */
                object-fit: contain;
                animation: zoomIn 0.3s ease;
                transition: transform 0.3s ease;
                transform-origin: center;
                cursor: zoom-in;
                pointer-events: auto; /* Гарантируем, что изображение кликабельно */
                display: block; /* Убираем возможные пробелы */
            }
            
            .image-modal__image.zoomed {
                max-width: none;
                max-height: none;
                transform: scale(2);
                cursor: zoom-out;
            }

            .image-modal__caption {
                margin-top: 20px;
                color: white;
                font-size: 14px;
                text-align: center;
                max-width: 600px;
                opacity: 0.9;
            }

            .image-modal__close {
                position: absolute;
                top: 20px;
                right: 20px;
                width: 40px;
                height: 40px;
                border: none;
                background: rgba(255, 255, 255, 0.1);
                backdrop-filter: blur(10px);
                color: white;
                border-radius: 50%;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.2s ease;
                z-index: 10;
            }

            .image-modal__close:hover {
                background: rgba(255, 255, 255, 0.2);
                transform: scale(1.1);
            }

            .image-modal__nav {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                width: 50px;
                height: 50px;
                border: none;
                background: rgba(255, 255, 255, 0.1);
                backdrop-filter: blur(10px);
                color: white;
                border-radius: 50%;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.2s ease;
                opacity: 0.7;
            }

            .image-modal__nav:hover {
                background: rgba(255, 255, 255, 0.2);
                opacity: 1;
                transform: translateY(-50%) scale(1.1);
            }

            .image-modal__nav--prev {
                left: 20px;
            }

            .image-modal__nav--next {
                right: 20px;
            }

            .image-modal__nav:disabled {
                opacity: 0.3;
                cursor: not-allowed;
            }

            .image-modal__nav:disabled:hover {
                background: rgba(255, 255, 255, 0.1);
                transform: translateY(-50%);
            }

            @keyframes fadeIn {
                from {
                    opacity: 0;
                }
                to {
                    opacity: 1;
                }
            }

            @keyframes zoomIn {
                from {
                    transform: scale(0.8);
                    opacity: 0;
                }
                to {
                    transform: scale(1);
                    opacity: 1;
                }
            }

            @media (max-width: 768px) {
                .image-modal__close {
                    top: 10px;
                    right: 10px;
                    width: 35px;
                    height: 35px;
                }

                .image-modal__nav {
                    width: 40px;
                    height: 40px;
                }

                .image-modal__nav--prev {
                    left: 10px;
                }

                .image-modal__nav--next {
                    right: 10px;
                }

                .image-modal__image {
                    max-width: 95vw;
                    max-height: 80vh;
                }
            }

            /* Предотвращаем скролл body когда модальное окно открыто */
            body.modal-open {
                overflow: hidden;
            }
        `;
        document.head.appendChild(style);
    }

    // Инициализация модального окна
    function initImageModal() {
        createImageModal();

        const modal = document.getElementById('imageModal');
        const modalImage = modal.querySelector('.image-modal__image');
        const modalImageWrapper = modal.querySelector('.image-modal__image-wrapper');
        const modalCaption = modal.querySelector('.image-modal__caption');
        const closeBtn = modal.querySelector('.image-modal__close');
        const overlay = modal.querySelector('.image-modal__overlay');
        const container = modal.querySelector('.image-modal__container');
        const content = modal.querySelector('.image-modal__content');
        const prevBtn = modal.querySelector('.image-modal__nav--prev');
        const nextBtn = modal.querySelector('.image-modal__nav--next');

        let currentImages = [];
        let currentIndex = 0;
        let isZoomed = false;

        // Функция открытия модального окна
        function openModal(imageSrc, imageAlt, images, index) {
            currentImages = images;
            currentIndex = index;
            isZoomed = false;
            
            modalImage.src = imageSrc;
            modalImage.alt = imageAlt || '';
            modalImage.classList.remove('zoomed');
            modalImageWrapper.classList.remove('zoomed');
            modalCaption.textContent = imageAlt || '';
            
            modal.classList.add('active');
            document.body.classList.add('modal-open');
            
            // Сброс скролла
            modalImageWrapper.scrollLeft = 0;
            modalImageWrapper.scrollTop = 0;
            
            // Устанавливаем правильные курсоры
            modalImageWrapper.style.cursor = 'pointer';
            modalImage.style.cursor = 'zoom-in';
            
            // Важно: сбрасываем размеры изображения чтобы не было невидимых областей
            modalImage.style.width = 'auto';
            modalImage.style.height = 'auto';
            
            // Обновляем состояние кнопок
            updateNavigationButtons();
        }

        // Функция закрытия модального окна
        function closeModal() {
            modal.classList.remove('active');
            document.body.classList.remove('modal-open');
            isZoomed = false;
            modalImage.classList.remove('zoomed');
            modalImageWrapper.classList.remove('zoomed');
        }
        
        // Функция переключения зума при клике на изображение
        function toggleZoom(e) {
            if (e) {
                e.stopPropagation();
            }
            
            isZoomed = !isZoomed;
            if (isZoomed) {
                modalImage.classList.add('zoomed');
                modalImageWrapper.classList.add('zoomed');
                modalImage.style.cursor = 'zoom-out';
                
            // Центрируем увеличенное изображение
            setTimeout(() => {
                modalImageWrapper.scrollLeft = (modalImageWrapper.scrollWidth - modalImageWrapper.clientWidth) / 2;
                modalImageWrapper.scrollTop = (modalImageWrapper.scrollHeight - modalImageWrapper.clientHeight) / 2;
            }, 10);
            
            // Устанавливаем курсор для wrapper в режиме зума
            modalImageWrapper.style.cursor = 'move';
            } else {
                modalImage.classList.remove('zoomed');
                modalImageWrapper.classList.remove('zoomed');
                modalImage.style.cursor = 'zoom-in';
                
                // Сброс скролла
                modalImageWrapper.scrollLeft = 0;
                modalImageWrapper.scrollTop = 0;
                
                // Возвращаем обычный курсор для wrapper
                modalImageWrapper.style.cursor = 'default';
            }
        }

        // Обновление кнопок навигации
        function updateNavigationButtons() {
            if (currentImages.length <= 1) {
                prevBtn.style.display = 'none';
                nextBtn.style.display = 'none';
            } else {
                prevBtn.style.display = 'flex';
                nextBtn.style.display = 'flex';
                prevBtn.disabled = currentIndex === 0;
                nextBtn.disabled = currentIndex === currentImages.length - 1;
            }
        }

        // Навигация по изображениям
        function navigateImage(direction) {
            if (direction === 'prev' && currentIndex > 0) {
                currentIndex--;
            } else if (direction === 'next' && currentIndex < currentImages.length - 1) {
                currentIndex++;
            }
            
            const image = currentImages[currentIndex];
            modalImage.src = image.src;
            modalImage.alt = image.alt || '';
            modalCaption.textContent = image.alt || '';
            
            // Сброс зума при переключении
            isZoomed = false;
            modalImage.classList.remove('zoomed');
            modalImageWrapper.classList.remove('zoomed');
            modalImage.style.cursor = 'zoom-in';
            modalImageWrapper.scrollLeft = 0;
            modalImageWrapper.scrollTop = 0;
            updateNavigationButtons();
        }

        // ЕДИНСТВЕННЫЙ ОБРАБОТЧИК НА ВЕСЬ МОДАЛ
        modal.addEventListener('click', (e) => {
            // Получаем элемент, на который кликнули и координаты клика
            const target = e.target;
            const rect = modalImage.getBoundingClientRect();
            const x = e.clientX;
            const y = e.clientY;
            
            // ПРОВЕРЯЕМ: клик внутри ВИДИМЫХ границ изображения
            const clickedOnImage = (
                target === modalImage &&
                x >= rect.left &&
                x <= rect.right &&
                y >= rect.top &&
                y <= rect.bottom
            );
            
            // Если кликнули ТОЧНО на видимую часть изображения
            if (clickedOnImage) {
                e.preventDefault();
                e.stopPropagation();
                toggleZoom();
                return;
            }
            
            // Если кликнули на кнопку закрытия или её содержимое
            if (target === closeBtn || closeBtn.contains(target)) {
                e.preventDefault();
                e.stopPropagation();
                closeModal();
                return;
            }
            
            // Если кликнули на кнопку "назад" или её содержимое
            if (target === prevBtn || prevBtn.contains(target)) {
                e.preventDefault();
                e.stopPropagation();
                navigateImage('prev');
                return;
            }
            
            // Если кликнули на кнопку "вперед" или её содержимое
            if (target === nextBtn || nextBtn.contains(target)) {
                e.preventDefault();
                e.stopPropagation();
                navigateImage('next');
                return;
            }
            
            // ВСЕ ОСТАЛЬНЫЕ КЛИКИ - ЗАКРЫВАЕМ МОДАЛ
            e.preventDefault();
            e.stopPropagation();
            closeModal();
        }, true); // используем захват события для приоритета

        // Обработка клавиш
        document.addEventListener('keydown', (e) => {
            if (!modal.classList.contains('active')) return;
            
            if (e.key === 'Escape') {
                if (isZoomed) {
                    toggleZoom();
                } else {
                    closeModal();
                }
            } else if (e.key === 'ArrowLeft') {
                navigateImage('prev');
            } else if (e.key === 'ArrowRight') {
                navigateImage('next');
            } else if (e.key === ' ' || e.key === 'Enter') {
                e.preventDefault();
                toggleZoom();
            }
        });

        // Обработка кликов по изображениям
        function handleImageClick(e) {
            const img = e.target;
            
            // Проверяем, что это изображение в контенте новости
            if (img.tagName !== 'IMG') return;
            
            // Проверяем, что изображение находится в контенте новости
            const isInNewsContent = img.closest('.news-show__body__text, .news-content, .news-show__body');
            if (!isInNewsContent) return;
            
            // Не открываем модальное окно для маленьких изображений (иконок)
            if (img.naturalWidth < 100 || img.naturalHeight < 100) return;
            
            e.preventDefault();
            e.stopPropagation();
            
            // Собираем все изображения в контейнере
            const container = img.closest('.news-show__body__text, .news-content');
            const allImages = container ? Array.from(container.querySelectorAll('img')).filter(i => 
                i.naturalWidth >= 100 && i.naturalHeight >= 100
            ) : [img];
            
            const imageData = allImages.map(i => ({
                src: i.src,
                alt: i.alt || i.title || ''
            }));
            
            const index = allImages.indexOf(img);
            
            openModal(img.src, img.alt || img.title || '', imageData, index >= 0 ? index : 0);
        }

        // Делегирование событий для динамически загружаемого контента
        document.addEventListener('click', handleImageClick);
    }

    // Функция для применения унифицированных отступов в карточках новостей
    function forceNewsCardSpacing() {
        // Создаем стиль с правильными отступами
        const criticalStyle = document.createElement('style');
        criticalStyle.id = 'news-spacing-fixes';
        criticalStyle.textContent = `
            /* УНИФИЦИРОВАННЫЕ ОТСТУПЫ ДЛЯ ВСЕХ КАРТОЧЕК НОВОСТЕЙ */
            
            /* Отступ между категорией (рубрикой) и заголовком - небольшой но видимый */
            .news-list__item-top,
            .news-list .news-list__item-top {
                margin: 0 !important;
                margin-bottom: 6px !important;
                padding-bottom: 0 !important;
            }
            @media (max-width: 1022px) {
                .news-list__item-body__text,
                .news-list .news-list__item-body__text {
                    margin-bottom: 10px !important;
                }
            }
            
            /* Заголовок новости */
            .news-list__item-body__title,
            .news-list .news-list__item-body__title {
                margin-top: 0 !important;
                margin-bottom: 12px !important;
                padding-top: 0 !important;
                padding-bottom: 0 !important;
            }
            
            /* Текст новости */
            .news-list__item-body__text,
            .news-list .news-list__item-body__text {
                margin-top: 0 !important;
                margin-bottom: 12px !important;
                padding-bottom: 0 !important;
            }
            
            /* Убираем влияние наличия картинки на отступы */
            .news-list__item-body {
                padding-top: 0 !important;
                margin-top: 0 !important;
            }
            
            /* Иконки и дополнительная информация внизу карточки */
            .news-list__item-bottom,
            .news-list .news-list__item-bottom {
                margin-top: 0 !important;
                padding-top: 12px !important;
            }
            @media (max-width: 1022px) {
                .news-list__item-bottom,
                .news-list .news-list__item-bottom {
                    margin-top: 10px !important;
                    padding-top: 14px !important;
                }
            }
            @media (min-width: 1023px) {
                .news-list__item-bottom,
                .news-list .news-list__item-bottom {
                    margin-top: 0 !important;
                    padding-top: 12px !important;
                }
            }
            
            /* Для карточек с картинкой - те же отступы */
            .news-list__item--with-image .news-list__item-body__title,
            .news-list__item.has-image .news-list__item-body__title {
                margin-bottom: 12px !important;
            }
            
            .news-list__item--with-image .news-list__item-body__text,
            .news-list__item.has-image .news-list__item-body__text {
                margin-bottom: 14px !important;
            }
            
            /* Для карточек без картинки - те же отступы */
            .news-list__item:not(.news-list__item--with-image) .news-list__item-body__title {
                margin-bottom: 12px !important;
            }
            
            .news-list__item:not(.news-list__item--with-image) .news-list__item-body__text {
                margin-bottom: 14px !important;
            }
            
            /* Убираем лишние отступы у оберток */
            .news-list__item-body-wrapper,
            .news-list__item-content,
            .news-list__item-wrapper {
                padding: 0 !important;
                margin: 0 !important;
            }
        `;
        
        // Удаляем старый стиль если есть и добавляем новый
        const oldStyle = document.getElementById('news-spacing-fixes');
        if (oldStyle) oldStyle.remove();
        document.head.appendChild(criticalStyle);
        
        // Применяем inline стили для гарантии
        const applyInlineSpacing = () => {
            document.querySelectorAll('.news-list__item').forEach(item => {
                // Проверяем наличие картинки и добавляем класс
                const hasImage = item.querySelector('.news-list__item-image, img[class*="news"], .news-img');
                if (hasImage) {
                    item.classList.add('has-image');
                } else {
                    item.classList.add('no-image');
                }
                
                // Категория/рубрика
                const category = item.querySelector('.news-list__item-top');
                if (category) {
                    category.style.setProperty('margin-bottom', '6px', 'important');
                    category.style.setProperty('padding-bottom', '0px', 'important');
                }
                
                // Заголовок
                const title = item.querySelector('.news-list__item-body__title');
                if (title) {
                    title.style.setProperty('margin-top', '0px', 'important');
                    title.style.setProperty('margin-bottom', '12px', 'important');
                    title.style.setProperty('padding-top', '0px', 'important');
                    title.style.setProperty('padding-bottom', '0px', 'important');
                }
                
                // Текст
                const text = item.querySelector('.news-list__item-body__text');
                if (text) {
                    text.style.setProperty('margin-top', '0px', 'important');
                    const textMarginBottom = window.innerWidth >= 1023 ? '12px' : '10px';
                    text.style.setProperty('margin-bottom', textMarginBottom, 'important');
                    text.style.setProperty('padding-bottom', '0px', 'important');
                }
                
                // Body контейнер
                const body = item.querySelector('.news-list__item-body');
                if (body) {
                    body.style.setProperty('padding-top', '0px', 'important');
                    body.style.setProperty('margin-top', '0px', 'important');
                }
                
                // Нижняя часть с иконками
                const bottom = item.querySelector('.news-list__item-bottom');
                if (bottom) {
                    const isDesktop = window.innerWidth >= 1023;
                    const marginTop = isDesktop ? '0px' : '10px';
                    const paddingTop = isDesktop ? '12px' : '14px';
                    bottom.style.setProperty('margin-top', marginTop, 'important');
                    bottom.style.setProperty('padding-top', paddingTop, 'important');
                }
            });
        };
        
        // Применяем сразу
        applyInlineSpacing();
        
        // Повторно применяем с задержками
        setTimeout(applyInlineSpacing, 100);
        setTimeout(applyInlineSpacing, 500);
        setTimeout(applyInlineSpacing, 1000);
        
        // Следим за изменениями DOM
        const observer = new MutationObserver(() => {
            applyInlineSpacing();
        });
        
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
    
    // Инициализация при загрузке DOM
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            initImageModal();
            forceNewsCardSpacing();
        });
    } else {
        initImageModal();
        forceNewsCardSpacing();
    }
})();
